import React, { useState } from "react";
import { Btn, H6, P } from "../../../../../AbstractElements";
import { LargeModals } from "../../../../../Constant";
import CommonModal from "../../Common/CommonModal";
import { ChevronsRight, CornerUpRight } from "react-feather";
import { LARGE_DATA } from "../../../../../Data/UiKit/Modal";

const LargeModal = () => {
  const [largeScreen, setLargeScreen] = useState(false);
  const largeScreenToggle = () => setLargeScreen(!largeScreen);
  return (
    <>
      <Btn color="success" type="button" onClick={largeScreenToggle}>{LargeModals}</Btn>
      <CommonModal size="lg" isOpen={largeScreen} toggle={largeScreenToggle} sizeTitle="Large modal" modalBodyClassName="dark-modal">
        <div className="large-modal-header"><ChevronsRight /><H6>Start with your goals </H6></div>
        <P className="modal-padding-space mb-0">No matter how talented you are as a content writer or creator, you will always fail if you don't have a clear set of goals.</P>
        <P className="modal-padding-space mb-0">First of all, without goals, there is no way to determine your success. Additionally, you lack direction.</P>
        <P className="modal-padding-space mb-0">Together with your team, respond to the following questions to make sure they are:</P>
        <div className="large-modal-body"><CornerUpRight /><P className="ps-1 mb-0">What must you achieve, and by when?</P></div>
        {LARGE_DATA.map((item, index) => (
          <div className="large-modal-body" key={index}><CornerUpRight /><P className="ps-1 mb-0">{item}</P></div>
        ))}
      </CommonModal>
    </>
  );
};

export default LargeModal;
